export default {
  number: 'number',
  text: 'text',
  date: 'date',
  datetime: 'datetime',
};
